import { faBell } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Inbox } from "@novu/react";
import { Badge, Space } from "antd";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import "./style.css";

function NovuInbox() {
    const history = useHistory();
    const userId = useSelector((state: any) => state.userLogin.user?.userId);

    if (!userId) {
        history.push("/");
        return null;
    }

    const appearance = {
        variables: {
            colorBackground: "white",
            colorPrimary: "#1990FE",
            colorForeground: "#000000",
            colorSecondaryForeground: "#000000",
            colorSecondary: "#000000",
            borderRadius: "0px",
        },
    };

    return (
        <Inbox
            applicationIdentifier={process.env.REACT_APP_NOVU_APPLICATION_IDENTIFIER || ""}
            subscriberId={userId}
            routerPush={(path: string) => history.push(path)}
            appearance={appearance}
            renderBell={(unreadCount) => (
                <Space size="small" className="nv-inbox-bell">
                    <Badge size="small" count={unreadCount} overflowCount={9} offset={[4, -1]}>
                        <FontAwesomeIcon icon={faBell} color="var(--header-text)" />
                    </Badge>
                </Space>
            )}
            onNotificationClick={(notification) => {
                if (notification?.data?.redirect_url) {
                    const url = notification?.data?.redirect_url;
                    if (typeof url === "string" && url) {
                        window.open(url, "_blank");
                    }
                }
            }}
        />
    );
}

export default NovuInbox;
